<template>
    <div class="flex">
        <vx-tooltip text="Bol.com bestelnummer">
            {{orderId}}
        </vx-tooltip>

        <vx-tooltip text="Kopieer bestelnummer">
            <font-awesome-icon class="fa-icon cursor-pointer ml-2"
                               :icon="['far', 'copy']"
                               style="font-size: 1.0rem"
                               @click="copyBolOrderId" />
        </vx-tooltip>
    </div>
</template>

<script>
export default {
	props: {
		orderId: {
			type: String,
			required: true
		},
	},
	methods: {
		copyBolOrderId() {
			this.$copyText(this.orderId).then(result => {
				this.$vs.notify({
					title: 'Yes!',
					text: 'Dit bestelnummer is succesvol naar je klembord gekopieerd!',
					color: 'success',
				});
			}).catch(error => {
				this.$vs.notify({
					title: 'Oops!',
					text: 'Het kopiëren is mislukt!',
					color: 'danger',
				});
			});
		},
	}
}
</script>
